import {
  GET_QUOTATION,
  GET_QUOTATION_NUMBER,
  SAVE_QUOTATION,
  GET_QUOTATION_BY_NUMBER,
  DELETE_QUOTATION,
  SAVE_EDIT_QUOTATION,
  DELETE_QUOTATION_ATTACHMENT,
  SAVE_QUOTATION_ATTACHMENT,
  SAVE_QUOTATION_SEARCH,
  SEND_EMAIL_QUOTATION,
  EXPORT_XLXS_QUOTATION,
  QUOTATION_GENERATE_PDF,
  QUOTATION_GENERATE_ZIP,
  CHANGE_STATUS_QUOTATION,
  QUOTATION_VOID
} from "../config/url";
import axios from "axios";
import authHeader from "./auth-header";

class QuotationService {
  quotationVoid(quotation_data) {
    return axios
      .post(QUOTATION_VOID, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  changeStatus(quotation_data) {
    return axios
      .post(CHANGE_STATUS_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  getList(quotation_data) {
    return axios
      .post(GET_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  // The export endpoints answer a failure with a non-2xx status and a
  // `{ status: "0", message: [...] }` body, so the original error is rethrown -
  // wrapping it in a new Error would throw that message away.
  exportXlxs(quotation_data) {
    return axios
      .post(EXPORT_XLXS_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  generatePdf(quotation_data) {
    return axios
      .post(QUOTATION_GENERATE_PDF, quotation_data, {
        headers: authHeader(),
        responseType: "blob", // the PDF is streamed back, named by Content-Disposition
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  generateZip(quotation_data) {
    return axios
      .post(QUOTATION_GENERATE_ZIP, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }
  searchList(quotation_data) {
    return axios
      .post(SAVE_QUOTATION_SEARCH, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  saveQuotation(quotation_data) {
    return axios
      .post(SAVE_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  saveQuotationAttachment(quotation_data) {
    return axios
      .post(SAVE_QUOTATION_ATTACHMENT, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  saveEditQuotation(quotation_data) {
    return axios
      .post(SAVE_EDIT_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  getQuotationNumber() {
    return axios
      .get(GET_QUOTATION_NUMBER, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  getQuotationByNumber(quotation_data) {
    return axios
      .post(GET_QUOTATION_BY_NUMBER, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  deleteQuotation(quotation_data) {
    return axios
      .post(DELETE_QUOTATION, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  deleteQuotationAttachment(quotation_data) {
    return axios
      .post(DELETE_QUOTATION_ATTACHMENT, quotation_data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  sendEmail(quotation_number) {
    return axios
      .post(SEND_EMAIL_QUOTATION, quotation_number, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  getQuotationByNumber(quotation_number) {
    return axios
      .post(GET_QUOTATION_BY_NUMBER, quotation_number, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
}

export default new QuotationService();
